import { AdaBindMethodPipe, TemplateMarkerDirectiveModule } from '@adaptiva/core/common';
import { AlertComponentModule } from '@adaptiva/widgets/alert';
import { ButtonComponentModule } from '@adaptiva/widgets/button';
import { CardComponentModule } from '@adaptiva/widgets/card';
import { CheckboxComponentModule } from '@adaptiva/widgets/checkbox';
import { ClickableComponentModule } from '@adaptiva/widgets/clickable';
import { ContainerComponentModule } from '@adaptiva/widgets/container';
import { HorizontalSeparatorComponentModule } from '@adaptiva/widgets/horizontal-separator';
import { InputComponentModule } from '@adaptiva/widgets/input';
import { LabelComponentModule } from '@adaptiva/widgets/label';
import { OverlayComponentModule } from '@adaptiva/widgets/overlay';
import { SpinnerComponent } from '@adaptiva/widgets/spinner';
import { TextComponentModule } from '@adaptiva/widgets/text';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ForgotPasswordOverlayModule } from './forgot-password';
import { LoginFormComponent } from './login-form.component';

@NgModule({
	imports: [
		AdaBindMethodPipe,
		AlertComponentModule,
		ButtonComponentModule,
		CardComponentModule,
		CheckboxComponentModule,
		ClickableComponentModule,
		CommonModule,
		ContainerComponentModule,
		ForgotPasswordOverlayModule,
		HorizontalSeparatorComponentModule,
		InputComponentModule,
		LabelComponentModule,
		OverlayComponentModule,
		SpinnerComponent,
		TemplateMarkerDirectiveModule,
		TextComponentModule,
	],
	declarations: [LoginFormComponent],
	exports: [LoginFormComponent]
})
export class LoginFormComponentModule {

}
